import { render } from "./index.vue?vue&type=template&id=41dd83c6"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=41dd83c6&lang=scss"
script.render = render

export default script